import { render, staticRenderFns } from "./NewTariffsOfDecember.vue?vue&type=template&id=4b4ffb90&"
import script from "./NewTariffsOfDecember.vue?vue&type=script&defer=true&lang=js&"
export * from "./NewTariffsOfDecember.vue?vue&type=script&defer=true&lang=js&"
import style0 from "./NewTariffsOfDecember.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports